import Vue from 'vue'
import Vuex from 'vuex'
import interceptor from './interceptor'
import user from './user'
import socketIo from './socketIo'
import callFilters from  './callFilters'
import orderFilters from  './orderFilters'
import warning from  './warning'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        interceptor,
        user,
        socketIo,
        callFilters,
        orderFilters,
        warning
    },
    actions: socketIo.actions,
    mutations: socketIo.mutations,
    state: socketIo.state
})